export function buildChartData(data, chartReport, carId) {
  let points = [];

  const unitChartData = data.units.filter((item) => {
    return item.info.id === carId;
  })[0];

  unitChartData.days.forEach((day) => {
    points = points.concat(day.rows);
  });

  const dataValues = {};

  points.forEach((point) => {
    Object.keys(point).forEach((key) => {
      if (key !== "TI") {
        const axis = chartReport.fields.filter((item) => {
          return item.dashboard.codes === key;
        })[0];

        if (!dataValues[key]) {

          dataValues[key] = {
            name: axis.dashboard.title,
            type: axis.chartAxis.type === 0 ? "line" : "area",
            showInLegend: true,
            color: axis.chartAxis.color,
            yValueFormatString: "#.### " + (axis.dashboard.valueAfter ? axis.dashboard.valueAfter : ""),
            xValueFormatString: "DD MM YYYY HH:mm:ss",
            dataPoints: [],
          };

          if (axis.chartAxis.useSecondaryAxis) {
            dataValues[key].axisYType = "secondary";
          }
        }

        dataValues[key].dataPoints.push({
          x: new Date(point["TI"].replace("Z", "")),
          y: getPointValue(point, key, axis),
          markerSize: 1.5,
        });
      }
    });
  });

  return dataValues;
}

function getPointValue(point, key, axis) {
  if (point[key] === null) {
    return null;
  }

  if (axis.dashboard.type === 13) {
    if (point[key] === "True") {
      return Number(axis.chartAxis.valueOn);
    } else {
      return null;
    }
  }

  return Number(point[key]);
}

export function getChartOptions(dataValues, height = 300) {
  const options = {
    height: height,
    theme: "light2",
    animationEnabled: true,
    zoomEnabled: true,
    exportEnabled: true,
    toolTip: {
      shared: true,
    },
    legend: {
      horizontalAlign: "center",
      verticalAlign: "top",
    },
    axisX: {
      valueFormatString: "DD.MM.YYYY HH:mm",
    },
    axisY: {
      crosshair: {
        enabled: true,
        snapToDataPoint: true,
      },
    },
    data: Object.values(dataValues),
  };

  return options;
}
